import { Box, Drawer, List, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import './MobileMarketingNavBar.scss';

interface MobileMarketingNavBarProps {
  menuOpen: boolean;
  handleMenuToggle: () => void;
}
export const MobileMarketingNavBar = (props: MobileMarketingNavBarProps) => {
  const navigate = useNavigate();
  const { handleMenuToggle, menuOpen } = props;

  return (
    <Drawer
      id="marketing-nav-bar"
      anchor="right"
      open={menuOpen}
      onClose={handleMenuToggle}
      slotProps={{
        backdrop: { style: { backgroundColor: 'transparent' } },
      }}
    >
      <List sx={{ paddingTop: '124px' }}>
        <Box sx={{ textAlign: 'center' }}>
          <Typography
            className="typography-item"
            onClick={() => {
              handleMenuToggle();
              void navigate('/search');
            }}
          >
            Find Your Land
          </Typography>
          <Typography
            className="typography-item"
            onClick={() => {
              handleMenuToggle();
              void navigate('/models');
            }}
          >
            Explore Models
          </Typography>
          <Typography className="typography-item">
            <a
              style={{ color: 'inherit', textTransform: 'none' }}
              href="https://www.immersivehomes.com/how-it-works"
              target="_blank"
              rel="noopener noreferrer"
            >
              How It Works
            </a>
          </Typography>
          <Typography className="typography-item">
            <a
              style={{ color: 'inherit' }}
              href="https://www.immersivehomes.com/about-us"
              target="_blank"
              rel="noopener noreferrer"
            >
              About Us
            </a>
          </Typography>
          <Typography className="typography-item">
            <a
              style={{ color: 'inherit' }}
              href="https://www.immersivehomes.com/contact"
              target="_blank"
              rel="noopener noreferrer"
            >
              Contact Us
            </a>
          </Typography>
        </Box>
      </List>
    </Drawer>
  );
};

